import styled from 'styled-components';
import { Text } from '@landr/maestro';

const TextDecorationUnderline = styled(Text)`
    user-select: none;
    a {
        text-decoration: underline;
        :hover {
            text-decoration: none;
        }
    }
`;

export default TextDecorationUnderline;
